<template>
  <v-form ref="form" v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container>
      <!--<v-row dense>
        <v-col>Width: {{ screenWidth }}  Height: {{ screenHeight }}</v-col>
      </v-row>
      -->
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <!-- {{searchCase}} -->
          <v-select
            :items="getCodeDateUtil('lang')"
            label="語言別"
            dense
            :rules="requiredRules"
            v-model="queryObject.serviceLanguage"
            @change="getInterpreterFromServer"
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="getCodeDateUtil('serveType')"
            label="服務類型"
            dense
            clearable
            v-model="queryObject.serviceType"
            @change="getInterpreterFromServer"
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="districtArray1"
            item-text="name"
            item-value="id"
            @change="districtObjectUtil(queryObject.serviceCity);getInterpreterFromServer()"
            label="服務地點"
            dense
            clearable
            v-model="queryObject.serviceCity"
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="districtArray2"
            item-text="name"
            item-value="id"
            label="服務地區"
            dense
            clearable
            v-model="searchCase.searchDistrict"
            @change="getDataByDistrict"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="searchCase.searchDate"
                @click:clear="searchCase.searchDate='';getInterpreterFromServer();"
                label="日期"
                readonly
                v-on="on"
                clearable
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              :min="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
              v-model="searchCase.searchDate"
              @input="menu = false"
              locale="zh-cn"
              style="font-family:Microsoft JhengHei;"
              color="red"
              @change="getInterpreterFromServer"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="getCommonArrayUtil('timeSolt')"
            label="時段"
            item-text="text"
            item-value="value"
            dense
            clearable
            v-model="searchCase.searchTime"
            @change="getInterpreterFromServer"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-btn color="red" block @click="resetObject">
            <font style="color:white">全部清除</font>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-toolbar-title>
          <v-row class="pa-3 ma-5" align="center" justify="center">
            <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="red" class="ml-2" v-on="on">
                  {{ pageSize }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-col>
              <v-col cols="12" md="12">
                <v-btn color="red" block @click="addAllItems">
                  <font style="color:white">全選</font>
                </v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-col cols="12" md="10">
          <v-data-iterator
            :items="items"
            :items-per-page.sync="pageSize"
            :page="currentPage"
            hide-default-footer
            no-data-text="查無資料"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="5" md="5" lg="6">
                  <v-card>
                    <v-card-title v-bind:class="{'red white--text':isItemExist(item)}">
                      <h3>{{ item.name }}</h3>
                      <h4>({{item.gender=='M'?'男':'女'}}) 案件數：{{ item.caseCount }}</h4>
                      <v-spacer />
                      <v-btn v-if="isHeartExist(item)" @click="deleteHeart(item)" class="ma-1">
                        <v-icon color="red">turned_in</v-icon>
                      </v-btn>
                      <v-btn v-if="!isHeartExist(item)" @click="addHeart(item)" class="ma-1">
                        <v-icon>turned_in_not</v-icon>
                      </v-btn>
                      <v-rating
                        readonly
                        v-model="item.score"
                        color="yellow darken-3"
                        background-color="grey darken-1"
                        empty-icon="$ratingFull"
                        half-increments
                        dense
                        hover
                      ></v-rating>
                      <v-spacer />
                      <v-btn @click="dialog = !dialog;memberItem = item;" class="ma-1">
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArrayPushObject(item);updateTargetId(item.name);addAlertUtil();"
                        class="ma-1"
                        v-if="!isItemExist(item)"
                      >
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArray.splice(findItemIndex(item),1)"
                        v-if="isItemExist(item)"
                        class="ma-1"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.nationality }}</v-list-item-content>
                          </template>
                          <span>國籍</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.qualificationInTaiwan }}</v-list-item-content>
                          </template>
                          <span>在臺資格與取得證件</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ convertDBDateToString(item.serviceStartDate) }}</v-list-item-content>
                          </template>
                          <span>開始從事通譯服務時間</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.educationLevel }}</v-list-item-content>
                          </template>
                          <span>教育程度</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.serviceType }}</v-list-item-content>
                          </template>
                          <span>服務類型</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.serviceLanguage }}</v-list-item-content>
                          </template>
                          <span>熟悉語言</span>
                        </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-slot:footer>
                <!-- <span class="red--text">每頁筆數</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="red" class="ml-2" v-on="on">
                      {{ pageSize }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span class="mr-4 red--text">Page {{ page }} / {{ maxPage }}</span>
                <v-btn fab dark color="red darken-3" class="mr-1" @click="formerPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="red darken-3" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>-->

                <div class="text-center pa-2 ma-2">
                  <v-pagination
                    color="red"
                    v-model="currentPage"
                    :length="maxPage"
                    :total-visible="9"
                    @input="getInterpreterFromServer()"
                  ></v-pagination>
                </div>
            </template>
          </v-data-iterator>
        </v-col>
        <v-col cols="12" md="2">
          <v-card
            v-show="selectedArray.length != 0"
            :style="{'top':offsetTop+'px','transition': 'all 0.5s'} "
          >
            <v-card-title>
              <h3>已選擇：{{selectedArray.length}}</h3>
            </v-card-title>
            <v-card-text v-for="(selectedItem,j) in selectedArray" :key="j">
              <h4>
                {{selectedItem.name}}
                <v-btn fab x-small @click="selectedArray.splice(j,1)">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </h4>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" block @click="submitObject">
                <font style="color:white">預約洽詢</font>
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn color="red" block @click="selectedArray=[]">
                <font style="color:white">清除所有人選</font>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="800px" v-if="dialog">
      <InterpreterDetail :memberItem="memberItem" v-on:childDialog="parentDialog"></InterpreterDetail>
    </v-dialog>
  </v-form>
</template>
<script>
import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getUserId: ["getUserId"],
      getTargetId: ["getTargetId"],
      getIcArray: ["getIcArray"],
      getSearchCase: ["getSearchCase"],
      getQueryObject: ["getQueryObject"],
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  data() {
    return {
      timer: false,
      timer2: false,
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      // date: new Date().toISOString().substr(0, 10),
      requiredRules: [v => !!v || "此欄位是必填，否則查無資料"],
      memberItem: {},
      date: null,
      menu: false,
      dialog: false,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      targetItem: {
        rating: 3.5,
        name: "王佳容",
        address: "100臺北市中正區重慶南路二段45號",
        fat: "越南",
        carbs: "中文、英文、越南語",
        protein: "衛生醫療、社會福利",
        sodium: "通譯人才巴拉巴拉巴拉相關認證",
        calcium: "14%",
        iron: "1%",
        a: "臺北市 : 中正區、大同區",
        b: "綜合社會福利、衛生醫療、就業輔導、陪同出庭、陪同偵訊、家庭暴力案件",
        c: "持中華民國身分證",
        d: "河內外語師範大學中文系畢業",
        e: "hyweb123@hyweb.com.tw",
        f: "02 2395 6966",
        g: new Date(),
        set: [
          {
            a: "臺北1OOOOO",
            b: new Date(),
            c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
            d1: 3.5,
            d2: 4.5,
            d3: 2,
            d4: 5
          },
          {
            a: "臺北2OOOOO",
            b: new Date(),
            c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
            d1: 3.5,
            d2: 4.5,
            d3: 2,
            d4: 5
          },
          {
            a: "臺北3OOOOO",
            b: new Date(),
            c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
            d1: 3.5,
            d2: 4.5,
            d3: 2,
            d4: 5
          }
        ]
      },
      selectedArray: [],
      selectOption: ["A", "B"],
      itemsPerPageArray: [4, 8, 12],
      currentPage: 1,
      maxPage: 0,
      pageSize: 4,
      totalCount: 0,
      items: [],
      fakeItems: [
        {
          rating: 3.5,
          name: "王佳容",
          address: "100臺北市中正區重慶南路二段45號",
          fat: "越南",
          carbs: "中文、英文、越南語、緬甸語、泰語",
          protein: "衛生醫療、社會福利",
          sodium: "通譯人才巴拉巴拉巴拉相關認證",
          calcium: "14%",
          iron: "1%",
          a:
            "臺北市 : 中正區、大同區、大同區、大同區、大同區\n新竹市\n臺中市\n嘉義縣\n臺南市\n高雄市",
          b:
            "綜合社會福利、衛生醫療、就業輔導、陪同出庭、陪同偵訊、家庭暴力案件",
          c: "持中華民國身分證",
          d: "河內外語師範大學中文系畢業",
          e: "hyweb123@hyweb.com.tw",
          f: "02 2395 6966",
          g: new Date(),
          h:
            "星期一 : 06:00-1200、1200-1800、1800-2400、2400-0600\n星期二 : \n星期三 : \n星期四 : \n星期五 : \n星期六 : \n星期日 :  ",
          set: [
            {
              a: "臺北1OOOOO",
              b: new Date(),
              c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
              f: "陪同偵訊",
              d1: 3.5,
              d2: 4.5,
              d3: 2,
              d4: 5
            },
            {
              a: "臺北2OOOOO",
              b: new Date(),
              c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
              f: "陪同偵訊",
              d1: 3.5,
              d2: 4.5,
              d3: 2,
              d4: 5
            },
            {
              a: "臺北3OOOOO",
              b: new Date(),
              c: "王小姐協助本局與移工通譯，服務態度佳，能在約定時間準時抵達",
              f: "陪同偵訊",
              d1: 3.5,
              d2: 4.5,
              d3: 2,
              d4: 5
            }
          ]
        },
        {
          name: "陳煌明",
          address: "100臺北市中正區重慶南路二段45號",
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          sodium: 129,
          calcium: "8%",
          iron: "1%"
        },
        {
          // name: "Eclair",
          // name: this.convertJsonDate(new Date(), "now"),
          name: "Derek",
          address: "100臺北市中正區重慶南路二段45號",
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          sodium: 337,
          calcium: "6%",
          iron: "7%"
        },
        {
          name: "Cupcake",
          address: "100臺北市中正區重慶南路二段45號",
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          sodium: 413,
          calcium: "3%",
          iron: "8%"
        },
        {
          name: "Gingerbread",
          address: "100臺北市中正區重慶南路二段45號",
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          sodium: 327,
          calcium: "7%",
          iron: "16%"
        },
        {
          name: "Jelly bean",
          address: "100臺北市中正區重慶南路二段45號",
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          sodium: 50,
          calcium: "0%",
          iron: "0%"
        }
      ],
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      searchCase: {},
      queryObject: {},
      dayArray: this.getCodeDateUtil("dayType"),
      heartArray: [],
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      offsetTop: 0
    };
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateTargetId",
      "updateIcArray",
      "updateSearchCase",
      "updateQueryObject",
      "updateTargetCaseId"
    ]),
    resetObject() {
      let vm = this;
      vm.searchCase = {};
      vm.queryObject = {};
      vm.selectedArray = [];

      vm.updateIcArray(vm.selectedArray);
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);

      vm.items = [];
      vm.currentPage = 1;
      vm.maxPage = 0;
      vm.pageSize = 4;
      vm.totalCount = 0;
      // this.getInterpreterFromServer();
    },
    addAllItems() {
      let vm = this;
      vm.items.forEach(item => {
        vm.selectedArrayPushObject(item);
      });
    },
    getDataByDistrict() {
      let vm = this;
      if (vm.isNotBlankUtil(vm.searchCase.searchDistrict))
        vm.queryObject.serviceCity = vm.searchCase.searchDistrict;
      vm.getInterpreterFromServer();
      vm.queryObject.serviceCity = vm.queryObject.serviceCity.split("-")[0];
    },
    submitObject() {
      var vm = this;
      var queryCloseCase = {};
      if (
        vm.userProfile.memberAccount.type == "AAA" &&
        !vm.userProfile.sysAdmin
      ) {
        queryCloseCase.deptId = vm.userProfile.memberAccount.mainDeptId;
      }
      queryCloseCase.status = "C04";
      var queryCloseCaseStr = JSON.stringify(queryCloseCase);

      var queryPagerStr = JSON.stringify({
        pageSize: 10,
        currentPage: 1
      });

      var criterionStr = JSON.stringify({
        isNull: [{ propertyName: "isCommentToInterpreter" }]
      });
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/interpreterCase?queryString=" +
            encodeURIComponent(queryCloseCaseStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          // vm.tableData = response.data.resultList;
          var totalCount = response.data.totalCount;
          if (totalCount == 0) {
            vm.updateIcArray(vm.selectedArray);
            vm.updateQueryObject(vm.queryObject);
            vm.updateSearchCase(vm.searchCase);
            vm.updateTargetCaseId("");
            vm.$router.push({
              path: "/contactInterpreter"
            });
          } else {
            vm.alertMessageUtil("已結案之案件尚未評價，評價後才能再開新案");
          }
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    isItemExist(item) {
      let vm = this;
      return vm.selectedArray.some(function(element) {
        return item.uuid == element.uuid;
      });
    },
    isHeartExist(item) {
      let vm = this;
      return vm.heartArray.some(function(element) {
        return item.uuid == element.pocketMemberId;
      });
    },
    addHeart(item) {
      let vm = this;
      var data = {
        memberId: vm.userProfile.memberAccount.uuid,
        pocketMemberId: item.uuid
      };
      vm.axios
        .post(vm.idbServerUrl + "idb/member/pocketMember", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          vm.heartArray.push(response.data);
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    deleteHeart(item) {
      let vm = this;
      var pocket = vm.heartArray.find(function(element) {
        return item.uuid == element.pocketMemberId;
      });
      vm.axios
        .delete(
          vm.idbServerUrl + "idb/member/pocketMember/" + pocket.pocketId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
          vm.heartArray.splice(vm.findHeartIndex(item), 1);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    findItemIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.uuid == element.uuid) itemIndex = index;
      });
      return itemIndex;
    },
    findHeartIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.heartArray.find(function(element, index) {
        if (item.uuid == element.pocketMemberId) itemIndex = index;
      });
      return itemIndex;
    },
    selectedArrayPushObject(item) {
      var vm = this;
      var selectedFlag = false;
      vm.selectedArray.forEach(function(element) {
        if (element.name == item.name) {
          selectedFlag = true;
        }
      });
      if (!selectedFlag) {
        vm.selectedArray.push(item);
      }
    },
    nextPage() {
      if (this.currentPage + 1 <= this.maxPage) this.currentPage += 1;
      this.getInterpreterFromServer();
    },
    formerPage() {
      if (this.currentPage - 1 >= 1) this.currentPage -= 1;
      this.getInterpreterFromServer();
    },
    updateItemsPerPage(number) {
      this.pageSize = number;
      this.getInterpreterFromServer();
    },
    parentDialog() {
      this.dialog = !this.dialog;
    },
    getInterpreterFromServer() {
      var vm = this;
      if (!vm.isNotBlankUtil(vm.queryObject.serviceLanguage)) {
        return;
      }

      console.log(vm.searchCase.searchDate);
      if (vm.isNotBlankUtil(vm.searchCase.searchDate)) {
        var dateDay = new Date(vm.searchCase.searchDate);
        var findDay = vm.dayArray.find(function(element) {
          return dateDay.getDay() == element.text;
        });
        vm.queryObject.serviceTime =
          findDay.value + vm.convertBlankUtil(vm.searchCase.searchTime);
      } else {
        vm.queryObject.serviceTime = vm.convertBlankUtil(
          vm.searchCase.searchTime
        );
      }
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);
      if (
        JSON.stringify(vm.queryObject) === "{}" &&
        JSON.stringify(vm.searchCase) === "{}"
      ) {
        vm.items = [];
        return;
      }
      var queryObjectStr = JSON.stringify(vm.queryObject);
      var queryPagerStr = JSON.stringify({
        pageSize: vm.pageSize,
        currentPage: vm.currentPage
        // sortColumnNameList: ["catShowOrder"]
      });

      var criterionStr = JSON.stringify({
          equal: [{propertyName: "type", value: "CCC"}, 
          {propertyName: "status", value: "Y"}]
      });

      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/memberAccount?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {          
          vm.items = response.data.resultList;
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;
          //console.log("items AA\n " + JSON.stringify(vm.items));
          if (vm.items != null && vm.items.length>0) {
            vm.items.forEach(element => {
              if (element.caseCount == null) {
                element.caseCount = 0;
              }
            });
          }
          //console.log("items BB\n " + JSON.stringify(vm.items));
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    },
    getHeartList() {
      let vm = this;
      var queryObjectStr = JSON.stringify({
        memberId: vm.userProfile.memberAccount.uuid
      });
      var queryPagerStr = JSON.stringify({
        pageSize: -1,
        currentPage: 1,
        sortColumnNameList: ["createDate"]
      });

      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/pocketMember?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList);
          //console.log(dataResponse);
          vm.heartArray = response.data.resultList;
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  },
  created() {
    // var vm = this;
    // vm.updateUser("updateUserDDDD");
    // vm.updateTargetId("updateTargetId");
  },
  watch: {
    screenWidth (val) {
        if (!this.timer) {
            this.screenWidth = val
            this.timer = true
            setTimeout(function () {
                // that.screenWidth = that.$store.state.canvasWidth
                //console.log(that.screenWidth)
                //this.init()
                this.timer = false
            }, 400)
        }
    },
    screenHeight (val) {
        if (!this.timer2) {
            this.screenHeight = val
            this.timer2 = true
            setTimeout(function () {
                // that.screenWidth = that.$store.state.canvasWidth
                //console.log(that.screenHeight)
                //this.init()
                this.timer2 = false
            }, 400)
        }
    }
  },
  mounted() {
    var vm = this;

    window.onresize = () => {
        return (() => {
            this.screenWidth = document.body.clientWidth
            this.screenHeight = document.body.clientHeight
        })()
    }
    
    window.addEventListener("scroll", function() {
      var scrollPos = document.documentElement.scrollTop - 400;
      if (scrollPos < 0) scrollPos = 0;
      if (vm.selectedArray.length > 4) scrollPos = 0;
      vm.offsetTop = scrollPos;
    });
    console.log("vm.getSearchCase " + JSON.stringify(vm.getSearchCase));
    console.log("vm.getQueryObject " + JSON.stringify(vm.getQueryObject));
    if (vm.getQueryObject != null || vm.getSearchCase != null) {
      if (vm.getQueryObject != null)
        vm.queryObject = JSON.parse(JSON.stringify(vm.getQueryObject));
      if (vm.getSearchCase != null)
        vm.searchCase = JSON.parse(JSON.stringify(vm.getSearchCase));

      vm.districtObjectUtil(vm.queryObject.serviceCity);
      vm.getInterpreterFromServer();
    }
    vm.selectedArray = vm.getIcArray;

    vm.getHeartList();
    vm.$refs.form.validate();
  }
};
</script>




